import { Col, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import { PiCaretCircleUpDownFill } from "react-icons/pi"
import LineImg from "../../../assets/images/AdminPortal/ReportsAndAnalytics/profit-line.svg"
import LineChart from "../../../components/common/AdminCommonComponents/Graphs/LineChart/LineChart"
import SalesDataCard from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/SalesDataCard/SalesDataCard"
import BarChart from "../../../components/common/AdminCommonComponents/Graphs/BarChart/BarChart"
import DonutChartComponent from "../../../components/AdminPortalComponents/Dashboard/SalesByDeviceChart"
import KPIChartStats from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/KPIChart/KPIChartStats"
import ProductDescCard from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/ProductDescCard/ProductDescCard"
import AsusRogKeyboard from "../../../assets/images/AdminPortal/ReportsAndAnalytics/asus-rog-keyboard.png"
import RoundedColoredDiv from "../../../components/AdminPortalComponents/ReportsAndAnalytics/SalesReports/RoundedColoredDiv/RoundedColoredDiv"
import RePieChart from "../../../components/common/AdminCommonComponents/Graphs/RePieChart/RePieChart"
import ChangeYearDropdown from "../../../components/common/AdminCommonComponents/ChangeYearDropdown/ChangeYearDropdown"

const CustomerAndUserAnalytics = () => {
  const chartData = [
    {
      name: "Jan",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "May",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ]

  const currentSalesData = [
    { title: "Current sales", value: "3%", revenue: "$192,065", lastYearRevenue: "$132,000 last year", lineImg: LineImg },
    { title: "Goal", value: "6%", revenue: "$192,065", lastYearRevenue: "$132,000 last year", lineImg: LineImg },
  ]

  const donutChartData = [
    { label: "Affiliated companies", value: 10 },
    { label: "Advertising campaigns", value: 15, strokeWidth: 15 },
  ]
  const donutChartColors = ["#2D4445", "#FBBD34"]
  const donutChartStats = [
    { divColor: "#2D4445", device: "Affiliated companies", sales: "$550.81", percentage: "15.3%" },
    { divColor: "#FBBD34", device: "Advertising campaigns", sales: "$830.03", percentage: "64.2%" },
  ]

  const topOrdersData = [
    {
      src: AsusRogKeyboard,
      title: "Asus ROG Strix Scope NX TKL Moonlight White - Red Switch",
      serialNumber: "#A1008",
      items: "15 items",
      totalSales: "1024 Sales",
    },
    { src: AsusRogKeyboard, title: "IQUNIX ZX75 Dark Side Wireless Mechanical Keyboard", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
    { src: AsusRogKeyboard, title: "K580 SLIM MULTI-DEVICE WIRELESS KEYBOARD", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
    { src: AsusRogKeyboard, title: "QUNIX OG80 Camping Wireless Mechanical Keyboard", serialNumber: "#A1008", items: "15 items", totalSales: "1024 Sales" },
  ]

  const pieChartFooterData = [
    { divColor: "#F4BE37", label: "Value - 01 (lt)", value: "12,423" },
    { divColor: "#FF9F40", label: "Value - 01 (lt)", value: "12,423" },
    { divColor: "#0D2535", label: "Value - 01 (lt)", value: "12,423" },
    { divColor: "#5388D8", label: "Value - 01 (lt)", value: "12,423" },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white p-3 shadow">
        <Row>
          <Col xs="12" lg="8">
            <div className="p-3 rounded shadow">
              <div className="d-flex align-items-center">
                <div className="fw-semibold flex-grow-1 flex-shrink-1 text-center">Average CLV</div>
                <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#16DBCC" size={18} />} />
              </div>

              <LineChart data={chartData} strokeColor="#16DBCC" />
            </div>
          </Col>
          <Col>
            <SalesDataCard salesData={currentSalesData} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs="12" lg="4">
            <div className="shadow p-3 rounded">
              <div className="text-center fw-semibold">Number of social media customers</div>
              <LineChart data={chartData} showDoubleLine />
            </div>

            <div className="shadow p-3 rounded mt-3">
              <div className="d-flex align-items-center justify-content-center">
                <DonutChartComponent data={donutChartData} colors={donutChartColors} />
              </div>

              <div className="text-center fw-semibold">
                <div>Clients referred by various sources</div>
              </div>

              <div className="mt-2">
                <KPIChartStats data={donutChartStats} />
              </div>
            </div>
          </Col>
          <Col>
            {/* bar chart section */}
            <div className="p-3 rounded shadow">
              <div className="d-flex align-items-center justify-content-between">
                <div className="fw-semibold">Customer satisfaction survey</div>
                <div>
                  <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#16DBCC" size={18} />} />
                </div>
              </div>

              <BarChart data={chartData} fillColor="#41B8E4" />
            </div>

            {/* line chart section */}
            <div className="mt-3 rounded shadow p-3">
              <div className="fw-semibold mb-2 text-center">Average purchase value trends</div>
              <LineChart data={chartData} strokeColor="#5388D899" stroke2Color="#FBBD34" showYAxis={false} showDoubleLine />
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs="12" lg="8">
            <div className="shadow p-3 rounded">
              <div className="fw-semibold">Geographical location of customers</div>
              <div className="d-flex align-items-center justify-content-center">
                <RePieChart
                  data={[
                    { name: "Group A", value: 400 },
                    { name: "Group B", value: 300 },
                    { name: "Group C", value: 300 },
                    { name: "Group D", value: 200 },
                  ]}
                  colors={["#5388D8", "#0D2535", "#fd9d49", "#f3bd44"]}
                />
              </div>

              <Row>
                {pieChartFooterData.map((item) => (
                  <Col>
                    <div className="d-flex gap-2">
                      <div className="my-2">
                        <div>
                          <RoundedColoredDiv backgroundColor={item.divColor} />
                        </div>
                      </div>
                      <div>
                        <div>{item.label}</div>
                        <div>{item.value}</div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          <Col xs="12" lg="4">
            <div className="p-3 rounded shadow">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="fw-semibold">Profitability of each product</div>
                  <div>Total:80 Orders</div>
                </div>
                <div className="rounded border px-2 py-1 d-flex align-items-center gap-1">
                  <span>Top Orders</span>
                  <PiCaretCircleUpDownFill fill="#41B8E4" size={18} />
                </div>
              </div>

              {topOrdersData.map((item, index) => (
                <ProductDescCard data={item} key={index} />
              ))}
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs="12" lg="8">
            <div className="shadow p-3 rounded">
              <div className="fw-semibold">DAU</div>
              <div className="d-flex align-items-center justify-content-center">
                <BarChart data={chartData} fillColor="#1814F3" secFillColor="#16DBCC" />
              </div>
            </div>
          </Col>
          <Col xs="12" lg="4">
            <div className="p-3 rounded shadow">
              <div className="fw-semibold">Tracking metrics(click rate)</div>

              <LineChart data={chartData} strokeColor="#1814F3" />
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs="12" lg="8">
            <div className="p-3 rounded shadow">
              <div className="fw-semibold">Requests over time</div>

              <LineChart data={chartData} strokeColor="#FCAA0B" />
            </div>
          </Col>
          <Col xs="12" lg="4">
            <div className="shadow p-3 rounded">
              <div className="d-flex align-items-center justify-content-between">
                <div className="fw-semibold">Support interactions</div>
                <ChangeYearDropdown options={[{ label: "2024" }, { label: "2025" }]} toggleIcon={<PiCaretCircleUpDownFill fill="#16DBCC" size={18} />} />
              </div>
              <div className="d-flex align-items-center justify-content-center">
                <BarChart data={chartData} fillColor="#FBBD34" secFillColor="#41B8E4" />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </LightGrayBgWrapper>
  )
}

export default CustomerAndUserAnalytics
